<div class="bg-white">
    <h2 class="settings-header px-4 py-3 mb-2 mb-md-5">
        {{'out_of_office_settings' | translate}} -
        <small>{{'out_of_office_settings_desc' | translate}}</small>
    </h2>
    
    <div class="settings-sub-header w-100 p-2">
        <h3 class="col-md-8 mx-auto px-md-4">
            <i class="far fa-suitcase"></i> {{ 'out_of_office_settings_absence' | translate}}
            <small>{{ 'out_of_office_settings_absence_desc' | translate}}</small>
        </h3>
    </div>

    <div class="bg-grey pt-4">
        <div class="col-md-8 mx-auto px-md-4 p-0 px-2">
            <div class="form-horizontal form-box">
                <h4 class="form-box-header">{{'outOfOffice' | translate}}</h4>
                <div class="form-group">
                    <div class="col-md-8 mx-auto">
                        <tm-out-of-office [(ngModel)]="teamMember.outOfOffice"
                                       (ngModelChange)="saveChanges()"></tm-out-of-office>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>